/* Muaazon premium motion: opt-in visual continuity, no commerce interception. */
(() => {
  'use strict';
  if (window.__mzPremiumMotionInstalled) return;
  window.__mzPremiumMotionInstalled=true;
  const reduced=matchMedia('(prefers-reduced-motion: reduce)');
  const pointer=matchMedia('(hover:hover) and (pointer:fine)');
  const dialog=()=>document.querySelector('[data-quick-view-dialog]');
  let pending=null;
  function clear() {
    if(!pending)return;
    pending.observer?.disconnect();
    clearTimeout(pending.timeout);
    pending.overlay?.remove();
    pending=null;
  }
  function reset() {
    clear();
    const node=dialog();
    if(!node)return;
    node.style.removeProperty('--mz-qv-offset-x');
    node.style.removeProperty('--mz-qv-offset-y');
  }
  function maybeAnimate() {
    const state=pending, node=dialog();
    if(!state||!node?.open||reduced.matches)return;
    const mount=node.querySelector('[data-quick-view-mount]');
    if(!mount||mount.hidden)return;
    const image=mount.querySelector('.product-gallery__image, .product-gallery img');
    if(!image||!image.complete||!image.naturalWidth)return;
    const target=image.getBoundingClientRect();
    if(target.width<24||target.height<24)return;
    const source=state.rect;
    if(source.width<24||source.height<24)return;
    const overlay=state.image.cloneNode(false);
    overlay.removeAttribute('srcset');
    overlay.removeAttribute('sizes');
    overlay.setAttribute('aria-hidden','true');
    overlay.style.cssText='position:fixed;display:block;pointer-events:none;z-index:2147483646;margin:0;padding:0;border:0;border-radius:14px;object-fit:cover;transform-origin:top left;will-change:transform,opacity;inset:auto;width:'+source.width+'px;height:'+source.height+'px;left:'+source.left+'px;top:'+source.top+'px;';
    document.body.appendChild(overlay);
    state.overlay=overlay;
    const dx=target.left-source.left,dy=target.top-source.top;
    const sx=target.width/source.width,sy=target.height/source.height;
    state.observer?.disconnect();
    try{
      const motion=overlay.animate([
        {transform:'translate3d(0,0,0) scale(1,1)',opacity:.92},
        {transform:'translate3d('+dx+'px,'+dy+'px,0) scale('+sx+','+sy+')',opacity:0}
      ],{duration:420,easing:'cubic-bezier(.22,1,.36,1)',fill:'forwards'});
      motion.finished.catch(()=>{}).finally(()=>{if(pending===state)clear();else overlay.remove()});
    }catch(error){clear()}
  }
  function start(trigger) {
    clear();
    const node=dialog();
    if(!node)return;
    const rect=trigger.getBoundingClientRect();
    const cx=rect.left+rect.width/2,cy=rect.top+rect.height/2;
    node.style.setProperty('--mz-qv-offset-x',Math.max(-90,Math.min(90,(cx-innerWidth/2)*.17)).toFixed(1)+'px');
    node.style.setProperty('--mz-qv-offset-y',Math.max(-70,Math.min(70,(cy-innerHeight/2)*.17)).toFixed(1)+'px');
    if(reduced.matches||!pointer.matches)return;
    const card=trigger.closest('.product-card__article,[data-product-card],.product-card');
    const image=card?.querySelector('img');
    if(!image?.complete||!image.naturalWidth||!node.querySelector('[data-quick-view-mount]'))return;
    pending={image,rect:image.getBoundingClientRect(),observer:null,timeout:null,overlay:null};
    const state=pending;
    state.observer=new MutationObserver(()=>requestAnimationFrame(maybeAnimate));
    state.observer.observe(node.querySelector('[data-quick-view-mount]'),{childList:true,subtree:true,attributes:true,attributeFilter:['hidden','src','class']});
    state.timeout=setTimeout(()=>{if(pending===state)clear()},2500);
  }
  document.addEventListener('click',event=>{
    if(event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
    const trigger=event.target.closest?.('[data-quick-view-trigger]');
    if(!trigger||trigger.matches('[disabled],[aria-disabled=true]'))return;
    start(trigger);
  },true);
  document.addEventListener('close',event=>{
    if(event.target.matches?.('[data-quick-view-dialog]'))reset();
  },true);
  document.addEventListener('shopify:section:unload',reset);
  if(reduced.addEventListener)reduced.addEventListener('change',()=>{if(reduced.matches)reset()});
})();